import { styled } from '@mui/material/styles';
import React from 'react';
import classNames from 'classnames';

const PREFIX = 'Indicator';

const classes = {
  indicator: `${PREFIX}-indicator`,
  dot: `${PREFIX}-dot`,
  activeDot: `${PREFIX}-activeDot`,
};

const Root = styled('ul')(({ theme }) => ({
  [`&.${classes.indicator}`]: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    textAlign: 'center',
  },

  [`& .${classes.dot}`]: {
    width: 14,
    height: 14,
    display: 'inline-block',
    borderRadius: '50%',
    opacity: 1,
    boxShadow: 'none',
    transition: 'background .5s',
    border: `0.5px solid ${theme.palette.primary.main}`,
    padding: 0,
    margin: '0 6px 0 0',
    outline: 0,
    cursor: 'pointer',
    background: theme.palette.common.white,
  },

  [`& .${classes.activeDot}`]: {
    background: theme.palette.secondary.main,
  },
}));

interface IProps {
  total: number;
  current: number;
  onDotClicked: (index: number) => void;
  className?: string;
}

const Indicator = (props: IProps) => {
  return props.total > 1 ? (
    <Root className={classNames(classes.indicator, props.className)}>
      {new Array(props.total).fill(0).map((_, i) => (
        <li key={i}>
          <button
            className={classNames(classes.dot, {
              [classes.activeDot]: i === props.current,
            })}
            onClick={() => props.onDotClicked(i)}
          />
        </li>
      ))}
    </Root>
  ) : null;
};

export default Indicator;
